import "./navbar.scss";
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { SearchBar } from "../../Other/Search/Search";

//calender import

import Cal from "../navbar/calender/Calendar";

import ProfileOptionsWrapper from "../ProfileOptions/ProfileOptionsWrapper";

import UserAvatar from "../UserAvatar/UserAvatar";

import axiosInstance from "../../../axios";
const { REACT_APP_PAYMENT_API_BASEURL } = process.env;

export default function Navbar() {
  const [lan, setLan] = useState(
    localStorage.getItem("language") ? localStorage.getItem("language") : "en"
  );

  const [notificationData, setNotificationData] = useState([]);

  // const { t } = useTranslation();
  const [notificationShow, setNotificationShow] = useState(false);
  const [calenderShow, setCalenderShow] = useState(false);
  const [reminderShow, setReminderShow] = useState(false);
  const [settingShow, setSettingsShow] = useState(false);
  const [profileShow, setProfileShow] = useState(false);
  const reminderRef = useRef(null);
  const calenderRef = useRef(null);
  const notificationRef = useRef(null);
  const settingRef = useRef(null);
  // const changeLanguage = (lng) => {
  //   setLan(lng);
  //   i18n.changeLanguage(lng);
  //   localStorage.setItem("language", lng);
  // };

  const fetch = () => {
    axiosInstance
      .get(`${REACT_APP_PAYMENT_API_BASEURL}/course-annnouncement`)
      .then((res) => {
        setNotificationData(res.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (calenderRef.current && !calenderRef.current.contains(event.target)) {
        setCalenderShow(false);
      }
      if (reminderRef.current && !reminderRef.current.contains(event.target)) {
        setReminderShow(false);
      }
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setNotificationShow(false);
      }
      if (settingRef.current && !settingRef.current.contains(event.target)) {
        setSettingsShow(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [reminderRef, calenderRef, settingRef, notificationRef]);

  //functions for the icons
  const calenderFunc = (event) => {
    event.preventDefault();
    setNotificationShow(false);
    setReminderShow(false);
    setSettingsShow(false);
    setProfileShow(false);
    calenderShow ? setCalenderShow(false) : setCalenderShow(true);
  };

  const notificationFunc = (event) => {
    event.preventDefault();
    setCalenderShow(false);
    setReminderShow(false);
    setProfileShow(false);
    setSettingsShow(false);
    notificationShow ? setNotificationShow(false) : setNotificationShow(true);
  };
  const reminderFunc = (event) => {
    event.preventDefault();
    setNotificationShow(false);
    setCalenderShow(false);
    setSettingsShow(false);
    setProfileShow(false);
    reminderShow ? setReminderShow(false) : setReminderShow(true);
  };
  const settingsFunc = (event) => {
    event.preventDefault();
    setNotificationShow(false);
    setReminderShow(false);
    setCalenderShow(false);
    setProfileShow(false);
    settingShow ? setSettingsShow(false) : setSettingsShow(true);
  };
  const profileFunc = (event) => {
    event.preventDefault();
    setNotificationShow(false);
    setReminderShow(false);
    setCalenderShow(false);
    setSettingsShow(false);
    profileShow ? setProfileShow(false) : setProfileShow(true);
  };

  const handleSelectOption = () => {
    profileShow ? setProfileShow(false) : setProfileShow(true);
  };

  //icon menu to map item dynamically

  const notificationDetails = [
    {
      notificationHeader: "Attention Student!",
      notificationDate: "Dec 16, 22",
      notificationMessage:
        "The Instructor wishes to cancel the class with a full refund,you refund you will be contacted  shortly",
    },
    {
      notificationHeader: "",
      notificationDate: "Dec 08, 22",
      notificationMessage:
        "Due to unavoidable circumstances, the class has been postponed to another date & time-you will be notified soon",
    },
  ];

  const iconMenu = [
    {
      key: 0,
      label: <Cal />,
      icon: "icon icon-calendar",
      toggleFunction: calenderFunc,
      forHiddenDiv: calenderShow,
      forRef: calenderRef,
      class: "span-absolute",
    },

    {
      key: 1,
      label: "Reminder",
      icon: "icon icon-reminder",
      toggleFunction: reminderFunc,
      forHiddenDiv: reminderShow,
      forRef: reminderRef,
      class: "span-absolute",
    },
    {
      key: 2,
      // label: notificationDetails,
      icon: "icon icon-notification",
      toggleFunction: notificationFunc,
      forHiddenDiv: notificationShow,
      forRef: notificationRef,
      class: "span-absolute-1",
      message: notificationData.length,
    },
    {
      key: 3,
      label: "Settings",
      icon: "profile-avatar",
      toggleFunction: settingsFunc,
      forHiddenDiv: settingShow,
      forRef: settingRef,
    },
  ];

  const languageOptinos = [
    { key: 0, value: "en", label: "EN", class: "english" },
    { key: 1, value: "fr", label: "FR", class: "french" },
  ];

  return (
    <div className="list">
      <div className="list-wrapper">
        <div className={`search-wrapper`}>
          <SearchBar variant="dashboard" />
        </div>

        <div className="nav-bar">
          <ul className="display-navbar-flex">
            <li className="listItems forTrans"></li>

            {iconMenu.map((item) => {
              return (
                <li className="listItem" key={item.key} ref={item.forRef}>
                  <a
                    href="/#"
                    aria-label="Menu Navigation"
                    className={item.forHiddenDiv ? "active" : null}
                  >
                    <div className="dashboard-navbar">
                      <span className={`${item.class}`}>
                        <p>{item?.message}</p>
                      </span>
                      <span
                        className={`${item.icon} image-new-fluid-1`}
                        onClick={item.toggleFunction}
                      ></span>
                    </div>
                  </a>
                  <div
                    className={item.forHiddenDiv ? "forIcons" : "hide"}
                    style={{
                      lineHeight: "1",
                      width: "190px",
                      padding: "0rem",
                      paddingTop: "10px",
                    }}
                  >
                    {notificationData.length > 0 ? (
                      notificationData?.map((ele, index) => (
                        <div className="notification-block">
                          <div
                            key={index}
                            style={{
                              backgroundColor: index === 0 && "#faf2ff",
                              padding: "10px",
                              // borderBottom:"1px solid grey"
                            }}
                          >
                            <label className="notificationHeader">
                              {ele?.name}
                            </label>
                            <label className="notificationDate">
                              {ele.createdAt}
                            </label>
                            <p className="notificationMessage">
                              {ele?.description}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div style={{ padding: "10px" }}>
                        <label className="notificationHeader">
                          {"No Notifications"}
                        </label>
                      </div>
                    )}

                    <div className="arrow-up"></div>
                    <ul>
                      {item.submenu !== undefined &&
                        item.submenu.map((subM) => {
                          return (
                            <Link to={"/" + subM.link} key={subM.key}>
                              <li onClick={subM.cb ? subM.cb : null}>
                                <i className={subM.icon} />
                                {subM.label}
                              </li>
                            </Link>
                          );
                        })}
                    </ul>
                  </div>
                </li>
              );
            })}
            <li href="/#" className="listItem">
              <a aria-label="Menu Navigation" href="/#" onClick={profileFunc}>
                <UserAvatar styleName="navbar-profile" navbar={true} />
              </a>
              {profileShow && (
                <ProfileOptionsWrapper onSelectOption={handleSelectOption} />
              )}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
